import React, { useEffect } from 'react';
import './Home.css'; // Home-specific styles
import 'aos/dist/aos.css';  // AOS styles
import AOS from 'aos';

function Home() {
  
  useEffect(() => {
    AOS.init({
      duration: 1200,  // Animation duration
      once: true,  // Only trigger animations once
      easing: 'ease-in-out',  // Smooth transitions
    });
  }, []);

  return (
    <div className="home-page"> 
     <div className="home-container" data-aos="zoom-in">
        <div className="content" data-aos="fade-up">
          <h1 className='head1'>Empowering Your Business</h1>
          <h2 className='head2'>with Technology and Digital Media Support</h2>
          <p className='head3'>Delivering cutting-edge professional services</p>
          <button
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              color: 'black',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
              alignItems: 'center',
              position: 'absolute',
              top: '-100'
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(200, 200, 200, 0.8)')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.8)')}
          >
            <a href="/" className="link">Learn More</a>
          </button>
        </div>
     </div>
      
     <div className="content2">
        <div className="leftSection" >
          <div className='leftcontainer'>    
            <h1 className="heading1" data-aos="fade-right">Let Your Data Take Your Business to the Next Level</h1>
            <p className="description1" data-aos="fade-right">
              At Davidson Technology Solutions, we believe that supporting our customers is the key to unlocking your business's true potential. Our team of experts can help empower you to make informed decisions that drive growth and success.
            </p>
          </div>
        </div>

        <div className="rightSection"  >
          <div className='fst'>
            <span className="icon" data-aos="fade-left">🌐</span> Cloud Solutions
            <h2 className="subheading" data-aos="fade-left">Cloud Solutions for Modern Businesses</h2>
            <p className="description" data-aos="fade-left">
              Our cloud analytics modernization services allow businesses to leverage the power of the cloud to store, analyze, and visualize their data more efficiently and effectively.
            </p>
          </div>

          <div className='snd'>
            <span className="icon"  data-aos="fade-left">📱</span> Digital Media
            <h2 className="subheading"  data-aos="fade-left">Customized Applications for Your Unique Needs</h2>
            <p className="description"  data-aos="fade-left">
              We understand that every business has unique needs. That's why we offer versatile and customizable applications that are tailored to your specific requirements.
            </p>
          </div>

          <div className='trd' >
            <span className="icon" data-aos="fade-left">🖥️</span> Custom Applications
            <h2 className="subheading" data-aos="fade-left">Accelerating Your Business with Cutting-Edge Digital Media</h2>
            <p className="description" data-aos="fade-left">
              Whether a TV commercial, podcast, professional presentation, logos, event graphics, or photography, our team will work closely with you to seamlessly produce all desired content using top-notch, state-of-the-art equipment and technology.
            </p>
          </div>

          <div className='fth' >
            <span className="icon" data-aos="fade-left">🤝</span> Customer Experience
            <h2 className="subheading" data-aos="fade-left">Providing Exceptional Customer Experience</h2>
            <p className="description"data-aos="fade-left">
              At Davidson Technology Solutions, we strive to provide our clients with the highest level of customer service and support.
            </p>
          </div>
        </div>
     </div>
      
     <div className='container3home' data-aos="zoom-in">
        <div className='innercontainerright'>
          <h2 className='containerh2' data-aos="zoom-in">Ready to Transform Your Business?</h2>
          <p className='containerp' data-aos="zoom-in">
            We understand that every business has unique needs.
            That's why we offer versatile and customizable applications that are tailored to your specific requirements.
          </p>
          <button className='button1'
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              color: 'black',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
              alignItems: 'center',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(200, 200, 200, 0.8)')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.8)')}
          >
            <a href="/" className="link">Get Started</a>
          </button>
        </div>

        <div className='innercontainerleft'>
          <div style={{ position: 'relative', height: '1000px', overflow: 'hidden', zIndex: 1 }}>
            <video
              src="/file.mp4"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                zIndex: 1,
              }}
              autoPlay
              loop
              muted
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>

      <div className='partnercontainer' data-aos="fade-up"><h4 className='Partnered with'>Partnered with:</h4></div>

      <div className='partnerhome'  style={{
        backgroundImage: `url(${process.env.PUBLIC_URL + '/5.png'})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '350px',
        width: '100%',
        position: 'relative',
        zIndex: 1,
      }} data-aos="fade-down">
      </div>
    </div>
  );
}

export default Home;
